import { css, styled } from 'styled-components';

const Container = styled.div<{
  $size?: number;
  $variant?: 'DARK_ROUNDED' | 'DEFAULT' | 'PURPLE_ROUNDED';
}>`
  ${({ $size = 24, $variant = 'DEFAULT', theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${$size}px;
    width: ${$size}px;
    min-width: ${$size}px;
    min-height: ${$size}px;
    border-radius: 50%;
    background-color: ${theme.colorsV2.gray05};
    text-align: center;
    color: ${theme.colorsV2.black};

    ${$variant === 'DARK_ROUNDED' &&
    css`
      background-color: ${theme.colorsV2.black};
      border-radius: 50%;

      & svg {
        color: ${theme.colorsV2.white};
      }
    `}

    ${$variant === 'PURPLE_ROUNDED' &&
    css`
      background-color: ${theme.colorsV2.brandPurple};
      border-radius: 50%;

      & svg {
        color: ${theme.colorsV2.white};
      }
    `}
  `}
`;

type Props = {
  readonly size?: number;
  readonly variant?: 'DARK_ROUNDED' | 'DEFAULT' | 'PURPLE_ROUNDED';
};

export const SelectMenuAddIcon = ({ size, variant }: Props) => {
  return (
    <Container
      $size={size}
      $variant={variant}
    >
      <svg
        focusable={false}
        height="100%"
        role="img"
        viewBox="0 0 24 24"
        width="100%"
      >
        <line
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          x1="9"
          x2="15"
          y1="50%"
          y2="50%"
        />
        <line
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          x1="50%"
          x2="50%"
          y1="9"
          y2="15"
        />
      </svg>
    </Container>
  );
};
